var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "nav notification-list" },
    [
      _vm.showingNavigation
        ? _vm._l(_vm.items, function(notification) {
            return _c("VueNotificationCard", {
              key: notification.id,
              attrs: { notification: notification },
              on: {
                notificationClick: _vm.onNotificationClick,
                dismissClick: _vm.onDismissClick,
                saveClick: _vm.onSaveClick
              }
            })
          })
        : _vm._e(),
      _vm._l(_vm.activeToasts, function(toast) {
        return _c("Toast", {
          key: toast.id,
          staticClass: "notification-list__toast-item",
          attrs: {
            visible: true,
            state: toast.state,
            iconClassName: toast.iconClassName,
            dismissibleTime: toast.dismissibleTime,
            siteLevel: toast.siteLevel,
            slim: true,
            title: toast.title,
            subtitle: toast.subtitle
          },
          on: {
            removed: function($event) {
              return _vm.dismissToastAction(toast.id)
            },
            close: function($event) {
              return _vm.dismissToastAction(toast.id)
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "bodyMsg",
                fn: function() {
                  return [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(toast.message) }
                    })
                  ]
                },
                proxy: true
              }
            ],
            null,
            true
          )
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }